module.exports = __webpack_public_path__ + "media/assets/images/blog/electrical_cabinet-small-35bbf24a37b7d53aa6f597d969764012.jpeg";